import { CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface PageLoaderProps {
  text?: string;
  className?: string;
}

const PageLoader = (props: PageLoaderProps) => {
  const { t } = useTranslation();
  const { text, className } = props;

  return (
    <div className={`loader ${className ? className : ""}`}>
      <CircularProgress />
      <Typography>{text || t("loading")}</Typography>
    </div>
  );
};

export default PageLoader;
